<template>
  <div @keyup.enter="enterSearch">
    <el-form :model="form" ref="form" class="table-search-bar" inline label-width="110px">
      <el-form-item label="主账号用户名" prop="rootUsername">
        <el-input v-model="form.rootUsername" placeholder="请输入主账号用户名"></el-input>
      </el-form-item>
      <el-form-item label="主账号客户名称" prop="rootCustomer">
        <el-input v-model="form.rootCustomer" placeholder="请输入主账号客户名称"></el-input>
      </el-form-item>
      <el-form-item label="子账号手机" prop="phone">
        <el-input v-model="form.phone" placeholder="请输入子账号手机"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
        <el-button type="primary" @click="handleAdd">新增</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      tooltip-effect="light"
      style="width: 100%">
      <el-table-column
        prop="mainUserName"
        label="主账号用户名"
        width="100"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="mainMobile"
        label="主账号手机"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="mainCustomerName"
        label="主账号客户名称"
        width="120"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        label="子账号类型"
        :formatter="typeFormatter"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="queryChildMobile"
        label="子账号手机"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="createPerson"
        label="添加人"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="添加时间"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="操作" width="540">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleCheck(scope.$index, scope.row)">查看</el-button>
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button
            size="mini"
            @click="handleAuthorize(scope.row)">{{scope.row.innerAuthorize === 1 ? '授权' : '取消授权'}}</el-button>
          <el-button
            size="mini"
            @click="handleOnOff(scope.row)">{{scope.row.status === 1 ? '开启' : '关闭'}}</el-button>
          <el-button
            size="mini"
            @click="handleLoginThaw(scope.row)" v-permission="'0031201'">登录密码解冻</el-button>
          <el-button
            size="mini"
            @click="handlePayThaw(scope.row)" v-permission="'0031202'">支付密码解冻</el-button>
          </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20 ,50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background>
    </el-pagination>
    <check-dialog :show.sync="checkDialogShow" :info="chekcDialogInfo" />
    <add-or-edit-dialog :show.sync="addOrEditDialogShow" :info="addOrEditDialogInfo" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import CheckDialog from './checkDialog'
import AddOrEditDialog from './addOrEditDialog'

export default {
  name: 'CustomerManagerDepartmentAccount',
  components: { CheckDialog, AddOrEditDialog },
  data () {
    return {
      form: {
        rootUsername: '',
        rootCustomer: '',
        phone: ''
      },
      addOrEditDialogShow: false,
      addOrEditDialogInfo: {},
      checkDialogShow: false,
      chekcDialogInfo: {},
      currentIndex: -1
    }
  },
  computed: {
    ...mapGetters({
      list: 'getCustomerManagerDepartmentAccountList',
      listState: 'getCustomerManagerDepartmentAccountListState'
    })
  },
  mounted () {
    this.handleSearch()
  },
  methods: {
    ...mapActions(['getCustomerManagerDepartmentAccountList', 'getCustomerManagerDepartmentAccountDetail', 'authorAccount', 'onOffAccount', 'accountLoginThaw', 'accountPayThaw']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    handleSizeChange (val) {
      this.getCustomerManagerDepartmentAccountList({ pageNo: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getCustomerManagerDepartmentAccountList({ pageNo: val })
    },
    handleSearch () {
      const params = {
        ...this.form,
        pageNo: 1
      }
      this.getCustomerManagerDepartmentAccountList(params)
    },
    handleAdd () {
      // 打开新增页面
      this.addOrEditDialogInfo = {}
      this.addOrEditDialogShow = true
    },
    handleReset () {
      this.$refs['form'].resetFields()
      this.handleSearch()
    },
    handleCheck (index, row) {
      // 打开查看界面
      this.formatCheckInfo(row)
      this.currentIndex = index
      this.checkDialogShow = true
    },
    handleEdit (index, row) {
      // 打开编辑界面
      this.addOrEditDialogInfo = {
        rootAccount: { accountId: row.accountId, userName: row.mainUserName },
        username: row.inChildUserName,
        phone: row.queryChildMobile,
        psw: '',
        paypsw: '',
        power: row.permissions || [],
        childAccountId: row.childAccountId
      }
      this.addOrEditDialogShow = true
    },
    handleAuthorize (row) {
      const status = row.innerAuthorize === 1 ? 2 : 1
      const params = {
        id: row.id,
        status,
        type: 2
      }
      if (status === 2) {
        // 授权
        this.authorAccount(params).then(() => {
          this.$message.success('操作成功')
          this.getListAndSetCheckInfo()
        })
      } else if (status === 1) {
        // 取消授权
        this.$confirm(
          '取消授权后，该用户无法通过该客户的名义进行线上操作！是否确认取消授权？',
          '取消授权',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          // 调接口
          this.authorAccount(params).then(() => {
            this.$message.success('操作成功')
            this.getListAndSetCheckInfo()
          })
        }).catch(() => {})
      }
    },
    handleOnOff (row) {
      const status = row.status === 1 ? 2 : 1
      const params = {
        id: row.id,
        status,
        type: 1
      }
      this.onOffAccount(params).then(() => {
        this.$message.success('操作成功')
        this.getCustomerManagerDepartmentAccountList()
      })
    },
    handleLoginThaw (row) {
      this.$confirm('解冻后，该用户可正常登陆！是否确认解冻？', '提醒', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.accountLoginThaw({ accountIds: [row.childAccountId] }).then(res => {
          this.$message.success('操作成功')
          this.getCustomerManagerDepartmentAccountList()
        })
      }).catch(() => {})
    },
    handlePayThaw (row) {
      this.$confirm('解锁后，该用户可正常支付！解锁？', '提醒', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.accountPayThaw({ accountIds: [row.childAccountId] }).then(res => {
          this.$message.success('操作成功')
          this.getCustomerManagerDepartmentAccountList()
        })
      }).catch(() => {})
    },
    getListAndSetCheckInfo () {
      this.getCustomerManagerDepartmentAccountList().then(res => {
        this.formatCheckInfo(res.list[this.currentIndex])
      })
    },
    formatCheckInfo (row) {
      this.chekcDialogInfo = {
        rootAccount: row.mainUserName,
        username: row.inChildUserName,
        phone: row.mainMobile,
        customer: row.mainCustomerName,
        power: row.permissions || [],
        childPhone: row.queryChildMobile,
        createPerson: row.createPerson,
        createTime: row.createTime,
        innerAuthorize: row.innerAuthorize,
        id: row.id
      }
    },
    typeFormatter (row) {
      return '部门账号'
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
